// "Look du jour" (homepage) : sur ordinateur, les 3 blocs sont dans la même ligne de grille et
// align-items:stretch (CSS dans sections/look-du-jour-split.liquid) leur donne deja la meme
// hauteur. Sur mobile, ils sont empiles (1 par ligne) et n'ont donc pas de hauteur commune via
// CSS Grid : on calque ici la hauteur du bloc central (photo + texte + CTA) sur celle d'un bloc
// "look" voisin, pour que les 3 blocs fassent toujours la meme taille.
(function () {
  function syncPromoHeight(section) {
    var promo = section.querySelector('.look-promo-split__promo');
    if (!promo) return;

    if (window.matchMedia('(min-width: 1000px)').matches) {
      // Sur ordinateur, align-items: stretch (CSS) fait deja le travail.
      promo.style.removeProperty('height');
      return;
    }

    var look = section.querySelector('.look-promo-split__look');
    if (!look) return;
    var h = look.getBoundingClientRect().height;
    if (h > 0) promo.style.setProperty('height', h + 'px', 'important');
  }

  document.querySelectorAll('.shopify-section--look-du-jour-split').forEach(function (section) {
    var look = section.querySelector('.look-promo-split__look');

    if (look && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        syncPromoHeight(section);
      }).observe(look);
    }

    window.addEventListener('load', function () {
      syncPromoHeight(section);
    });
    window.addEventListener('resize', function () {
      syncPromoHeight(section);
    });
  });
})();
